import moment from "moment";

export function getStateIcon(state) {
  switch (state) {
    case "Новая": return "mdi-new-box";
    case "Подтверждена": return "mdi-check-all";
    case "Не подтверждена": return "mdi-cellphone-basic";
    case "В обработке": return "mdi-autorenew";
    case "Отказ клиента": return "mdi-account-remove-outline";
    case "Нет машин": return "mdi-car-off";
    case "Недозвон": return "mdi-phone-off-outline";
    case "Ожидает ответа клиента": return "mdi-account-question-outline";
    case "Ожидает оплаты": return "mdi-currency-usd-off";
    case "Активная": return "mdi-alpha-a-circle-outline";
    case "Отмена": return "mdi-cancel";
    case "Отъездила": return "mdi-garage-variant";
    case "Вернуть залог": return "mdi-keyboard-return";
    default: return "mdi-head-question-outline";
  }
}

export function getStateColor(state) {
  switch (state) {
    case "Новая": return "primary";
    case "Подтверждена": return "success";
    case "Не подтверждена": return "warning";
    case "В обработке": return "primary";
    case "Отказ клиента": return "error";
    case "Нет машин": return "secondary";
    case "Недозвон": return "warning";
    case "Ожидает ответа клиента": return "pink";
    case "Ожидает оплаты": return "lime";
    case "Активная": return "light-blue";
    case "Отмена": return "brown";
    case "Отъездила": return "light-green";
    case "Вернуть залог": return "blue";
    default: return "secondary";
  }
}

export function checkLateDate(date) {
  if (!moment().isSameOrBefore(moment(date, "DD-MM-YYYY H:mm"), "day")) {
    return "color: tomato;";
  }
  return "";
}

export function formatDateBookingDates(date) {
  return moment(date, "DD-MM-YYYY H:mm").format("DD MMM");
}

export function formatTimeBookingDates(date) {
  return moment(date, "DD-MM-YYYY H:mm").format("H:mm");
}

// Flatten a JSON:API column payload ({ data, included }) into plain booking objects,
// mirroring Bookings.vue#getDataFromApi (counts flatten + full_name derivation).
// `tasksMap` (optional) is the column's `tasks` summary keyed by booking id
// ({ "<id>": { count, previews } }) — merged in as tasks_count/tasks_preview.
export function mapBoardColumn(payload, tasksMap) {
  if (!payload || !payload.data) return [];
  const included = payload.included || [];
  const tasks = tasksMap || {};
  return payload.data.map((entry) => {
    const attributes = { ...entry.attributes };
    attributes.counts = [];
    const rel = entry.relationships && entry.relationships.counts;
    if (rel && rel.data) {
      rel.data.forEach((item) => {
        included
          .filter((count) => count.id == item.id)
          .forEach((count) => attributes.counts.push(count.attributes));
      });
    }
    attributes.full_name = attributes.entity
      ? `${attributes.entity_name}`
      : `${attributes.last_name} ${attributes.first_name}`;
    const t = tasks[attributes.id] || { count: 0, previews: [] };
    attributes.tasks_count = t.count || 0;
    attributes.tasks_preview = t.previews || [];
    return attributes;
  });
}
